import { graphql } from '@newfront-insurance/graphql-frontend';

export const MARK_CHAT_AS_READ = graphql(`
  mutation MarkChatAsRead($chatUuid: String!) {
    markChatAsRead(chatUuid: $chatUuid) {
      uuid
      hasUnreadMessages
      activeStreamId
    }
  }
`);

export const GET_NOVA_SETTINGS = graphql(`
  query GetNovaSettings($userUuid: String!) {
    getNovaSettings(userUuid: $userUuid) {
      notificationsEnabled
      outlookConnectEnabled
      outlookConnectedEmailGroupIds
      outlookSharedInboxes
    }
  }
`);

export const UPDATE_NOVA_SETTINGS = graphql(`
  mutation UpdateNovaSettings(
    $userUuid: String!
    $notificationsEnabled: Boolean
    $outlookConnectEnabled: Boolean
    $outlookConnectedEmailGroupIds: [String!]
    $outlookSharedInboxes: [String!]
  ) {
    updateNovaSettings(
      userUuid: $userUuid
      notificationsEnabled: $notificationsEnabled
      outlookConnectEnabled: $outlookConnectEnabled
      outlookConnectedEmailGroupIds: $outlookConnectedEmailGroupIds
      outlookSharedInboxes: $outlookSharedInboxes
    ) {
      notificationsEnabled
      outlookConnectEnabled
      outlookConnectedEmailGroupIds
      outlookSharedInboxes
    }
  }
`);
